import React, {useCallback, useRef, useState} from 'react';
import withStore from "@/hocs/withStore";
import {isDesktop, isMobile} from "@/Helpers/Function";
import isEmpty from "is-empty";
import MyVideoPlayer from "@/Pages/All/MyVideoPlayer";
import LightboxImage from "react-image-lightbox";
import Svg from "@/Pages/All/Svg";
import ShareAndFavouritesComponent from "@/Pages/Product/ShareAndFavouritesComponent";
import {Swiper, SwiperSlide} from "swiper/react";
import {Mousewheel, Pagination, Thumbs} from "swiper/modules";

const MainSliderComponent = (props) => {
    const {product = {}, config = {}} = props;
    const {imgDetail = null, h1 = '', article = ''} = product;
    const {defaultImage = {}} = config;

    const swiperPaginationRef = useRef(null);

    const [photoIndex, setPhotoIndex] = useState(0);
    const [isOpen, setIsOpen] = useState(false);
    const handleSlideChange = (index) => {
        setPhotoIndex(index);
    };
    const [thumbsSwiper, setThumbsSwiper] = useState(null);

    let images = !isEmpty(imgDetail) ? imgDetail.split(';').filter((el) => !el.includes('mp4')) : [];

    let sliderElements = [], paginationElements = [];

    const ArrowUp = () => {
        let className = 'swiperNavigationContainer__arrow swiperNavigationContainer__arrow_up';

        const handlePrev = useCallback(() => {
            if (!swiperPaginationRef.current) return;
            swiperPaginationRef.current.swiper.slidePrev();
        }, []);

        return <div className={className} onClick={handlePrev}>
            <Svg id={`arrows-up`} className={`svg__swiperArrow`} />
        </div>
    }

    const ArrowDown = () => {
        let className = 'swiperNavigationContainer__arrow swiperNavigationContainer__arrow_down';

        const handleNext = useCallback(() => {
            if (!swiperPaginationRef.current) return;
            swiperPaginationRef.current.swiper.slideNext();
        }, []);

        return <div className={className} onClick={handleNext}>
            <Svg id={`arrows-down`} className={`svg__swiperArrow`} />
        </div>
    }

    const swiperSettings = {
        spaceBetween: 10,
        freeMode: true,
        pagination: true,
        className: 'productMainSlider',
        modules: [Thumbs, Pagination],
        // Responsive breakpoints
        breakpoints: {
            // when window width is >= 320px
            320: {
                pagination: {
                    clickable: true,
                    dynamicBullets: true,
                },
            },
            // when window width is >= 992px
            992: {
                pagination: false,
            },
        }
    };

    const swiperPaginationSettings = {
        spaceBetween: 20,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,
        className: 'productMainSliderPagination',
        direction: 'vertical',
        mousewheel: true,
        modules: [Mousewheel]
    };

    if (isEmpty(imgDetail)) {
        sliderElements.push(
            <picture key={0}>
                <source type={`image/webp`} srcSet={defaultImage.detailedPathWebp} />
                <img src={defaultImage.detailedPath}
                     alt={h1 + ' ' + article}
                     title={h1 + ' ' + article}
                />
            </picture>
        )
    } else {
        imgDetail.split(';').map((src, i) => {
            if (!isEmpty(src) && src.indexOf('mp4') !== -1) {
                sliderElements.push(
                    <SwiperSlide key={i}>
                        <MyVideoPlayer src={src} />
                    </SwiperSlide>
                )
                paginationElements.push(
                    <SwiperSlide key={i}>
                        <MyVideoPlayer src={src} />
                    </SwiperSlide>
                )
            } else {
                let imgWebp = src;
                if (src.includes('png')) {
                    imgWebp = src.replace('png', 'webp');
                }
                if (src.includes('jpg')) {
                    imgWebp = src.replace('jpg', 'webp');
                }
                if (src.includes('jpeg')) {
                    imgWebp = src.replace('jpeg', 'webp');
                }

                sliderElements.push(
                    <SwiperSlide key={i}>
                        <picture onClick={() => {
                            setPhotoIndex(i);
                            setIsOpen(true);
                        }}>
                            <source type={`image/webp`} srcSet={imgWebp} />
                            <img src={src}
                                 className={`productMainImage`}
                                 alt={h1 + ' ' + article}
                                 title={h1 + ' ' + article}
                            />
                        </picture>
                    </SwiperSlide>
                )

                paginationElements.push(
                    <SwiperSlide key={i}>
                        <picture>
                            <source type={`image/webp`} srcSet={imgWebp} />
                            <img src={src} alt={h1 + ' ' + article} title={h1 + ' ' + article} />
                        </picture>
                    </SwiperSlide>
                )
            }
        })
    }

    return <>
        {isOpen && (
            <LightboxImage
                mainSrc={images[photoIndex]}
                nextSrc={images[(photoIndex + 1) % images.length]}
                prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                onCloseRequest={() => setIsOpen(false)}
                onMovePrevRequest={() => handleSlideChange((photoIndex + images.length - 1) % images.length)}
                onMoveNextRequest={() => handleSlideChange((photoIndex + 1) % images.length)}
            />
        )}
        <div className={`product__main-slider`}>
            {isDesktop() && (
                <div className={`swiperNavigationContainer`}>
                    <Swiper ref={swiperPaginationRef} onSwiper={setThumbsSwiper} {...swiperPaginationSettings} >
                        {paginationElements}
                    </Swiper>
                    {swiperPaginationRef.current !== null && swiperPaginationRef.current.swiper !== null && !swiperPaginationRef.current.swiper.isLocked && (
                        <>
                            <ArrowUp />
                            <ArrowDown />
                        </>
                    )}
                </div>
            )}
            <Swiper thumbs={{swiper: thumbsSwiper}} {...swiperSettings} >
                {sliderElements}
            </Swiper>
            {isMobile() && (
                <>
                    <div className={`backProductButton`} onClick={() => window.history.back()}>
                        <Svg id={`arrows-left-product`} className={`svg__backProductButton`} />
                    </div>
                    <ShareAndFavouritesComponent {...props} />
                </>
            )}
        </div>
    </>
}

export default withStore(MainSliderComponent);
